// Reference-only unit labels (Bag/Can/Case/Box/Other) — pluralized for display.
// No conversion math lives here; this only affects text.
const IRREGULAR_PLURALS = { box: "boxes", other: "other" };

export const pluralUnit = (unitType, qty) => {
  if (qty === 1) return unitType;
  return IRREGULAR_PLURALS[unitType] || `${unitType}s`;
};
